<template lang="pug">
#app(:class="appClass")
  router-view(name='header')
  div#page
    router-view(name='menu')
    router-view(:key="$route.fullPath")
    div#page-overlay(:class="spinner ? 'spinner' : ''")
      div#geno-spinner(style="text-align: center")
        .spin-container(style="width: 136px; height: 100vh; display: inline-block;")
          geno-logo.spinner(:class="spinner ? 'rotateLoading' : ''" style="width: 136px; height: 136px;" )
          el-progress.progress(v-if="progress > 0" type="circle" :percentage="progress" :width="256" :height="256" :stroke-width="0" firstcolor="#1bc18b" color="#2e668c" )
    //main
        transition(:name="transitionName" v-on:before-enter="debug" v-on:before-leave="debug")
          router-view
  v-dialog(@before-open="beforeOpen" @before-close="beforeClose")
</template>
<script>
import axios from 'axios'
import {
    store
} from "./Store"
import { AmplifyEventBus } from 'aws-amplify-vue';
  let resizeTimeout;
  function resizeThrottler(actualResizeHandler) {
    if ( !resizeTimeout ) {
      resizeTimeout = setTimeout(() => {
        resizeTimeout = null;
      }, 66);
    }
  }
export default {
  name: 'app',
  components: {
  },
  data() {
    return {
      transitionName: "",
    };
  },
  watch: {
    $route(to, from) {
      this.transitionName = to.meta.page > from.meta.page ? "next" : "prev";
    }
  },
  methods: {
      beforeOpen(event) { console.log('open ', event) },
      beforeClose(event) { console.log('close ', event) },
      scrollListener() {
        resizeThrottler(this.handleScroll)
      },
  handleScroll() {
        let container = document.getElementById('app')
        let scrollValue = container.scrollTop || 0
        this.appClass =  ( scrollValue > 75 ? 'scrolled' : 'unscrolled' )
        },
    debug() {
      //debugger
    }
  },
  computed: {
       appClass: {
        set: function(value) {
        this.$store.commit('change', {appclass: value})
        },
        get: function(value) {
        return this.$store.getters.get('appclass') 
        }
        },
        spinner: function() { 
        return store.getters.get('spinner') },
        progress: function() { return store.getters.get('progress') },
        },
    mounted () {
      this.$store.commit('change', { spinner: false })
      var container = document.getElementById('app')
      container.addEventListener('scroll', this.scrollListener)
    },
    beforeDestroy () {
      var container = document.getElementById('app')
      container.removeEventListener('scroll', this.scrollListener)
    },
beforeCreate(){
         let stage = store.getters.get('env') === 'production' ? '' : 'staging/';
         axios.get('/json/procedures.json').then(response => {
         if ( response && response.data && response.data.length > 0 ) { store.commit('change', { proceduresArr: response.data }) }
                              })
},
  created () {
  }
  }
</script>
<style src="./style/vue-multiselect.min.css"></style>
<style lang="scss">
@import "../node_modules/ag-grid-community/dist/styles/ag-grid.css";
@import "../node_modules/ag-grid-community/dist/styles/ag-theme-material.css";
body #page-overlay.spinner {
    opacity: 1;
    position: fixed;
        width: 100%;
            height: 100%;
            pointer-events: none;
                background-color: #0000000f;
                    z-index: 15;
                    transition: all 0.3s;
                    }
body #page-overlay {
    opacity: 0;
    position: fixed;
    top: 0;
        width: 100%;
            height: 100%;
            pointer-events: none;
                background-color: #00000000;
                    z-index: 1;
                    transition: all 0.3s;
                    }
#geno-spinner {
text-align: center;
}
#geno-spinner .spin-container {
        height: 100vh;
                    display: inline-block;
                    }
#geno-spinner svg.spinner {
    position: relative;
    top: 35%;
    background: #f33e3e;
    background: #4e88b5;
    background: #2a465c87;
    border-radius: 99px;
}

#geno-spinner .progress {
position: relative;
top: 35%;
width: 136px;
height: 136px;
margin-top: -40px;
background: rgba(0,0,0,0);
color: white;
}

body.dark #geno-spinner svg.spinner {
background: hsl(206, 16%, 40%);
background: hsla(206, 25%, 65%, 0.5);
}

body #app .page-header:before {
    background-color: rgba(204, 204, 203, 1);
    }
body #app #page {
    background: #cccccb;
    }
body #app #createnew {
color: #454141;
text-shadow: 2px 3px 5px rgba(0,0,0,0.5);
    color: #787878;
    color: #484747;
        text-shadow: 0px 1px 1px #ffffff;
        font-weight: 700;
}

body.sidebar-menu #app .navbar {
z-index: 1;
}
body.sidebar-menu #app .navbar-translate {
    }

.tooltip .tooltip-inner {
cursor: default;
}
body.lookup .navbar a:not(.btn):not(.dropdown-item) {
	    color: gray;
    }
body #statusLogo.warn .logo {
background: #194d6be3
}

#app .btn-primary {
background-color: #E46F49 !important;
background-color: #E65929 !important;
}
#cb-container {
overflow: hidden !important;
}



body.presentation-page {
background-color: #354c5e !important;
}
body.presentation-page .bg-white {
background-color: #4b0d02 !important;
color: white;
}

body.presentation-page .navbar.bg-white:not(.navbar-transparent) a:not(.dropdown-item):not(.btn) {
    color: white;
    }

    .presentation-page .bg-white .credits {
        background-color: #bb6d6d73;
            color: white;
        }

body {
overflow: hidden;
width: calc(100% + 20px);
}

#app {
  display: grid;
  grid-template-rows: min-content;
  min-height: 100%;
  overflow-y: scroll;
  overflow-x: hidden;
  padding-right: 0px;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}



/* Transitions */
main > * {
  background-color: white;
  position: relative;
}

main > :first-child {
  z-index: 1;
}

.next-leave-to {
  animation: leaveToLeft 200ms;
  z-index: 0;
}

.next-enter-to {
  animation: enterFromRight 200ms;
  z-index: 1;
}

.prev-leave-to {
  animation: leaveToRight 200ms;
  z-index: 1;
}

.prev-enter-to {
  animation: enterFromLeft 200ms both cubic-bezier(0.165, 0.84, 0.44, 1);
  z-index: 0;
}

@keyframes leaveToLeft {
  from {
    transform: translateX(0);
    filter: opacity(0.1);
  }
  to {
    transform: translateX(-100%);
  }
}

@keyframes enterFromLeft {
  from {
    transform: translateX(-100%);
  }
  to {
    transform: translateX(0);
    filter: opacity(0.1);
  }
}

@keyframes leaveToRight {
  from {
    transform: translateX(0);
  }
  to {
    transform: translateX(100%);
  }
}

@keyframes enterFromRight {
  from {
    transform: translateX(100%);
  }
  to {
    transform: translateX(0);
  }
}

.overlay-left,  .overlay-right,  .overlay-top,  .overlay-bottom   { 
background: #cda69d !important;
}
.Section__sectionBody___3DCrX, .Section__sectionFooter___1QlDn {
max-width: 67%;
}
#app .btn-primary, #app .btn-round, #app .btn-icon {
box-shadow: 0px 5px 35px 0px rgba(0, 0, 0, 0.3);
}
#app .v--modal-overlay {
background-color: rgba(0,0,0,0.3);
}

#app .v--modal {
border-radius: 7px;
}
.Section__sectionBody___ihqqd, .Section__sectionFooter___1T54C, .Section__sectionBody___ihqqd, .Section__sectionFooter___1T54C  {
max-width: 67%;
}
#app .rotateLoading {                                                                                                       animation: rotation 1s infinite linear;
    box-shadow: none !important;
}
@keyframes rotation {
    from {
        transform: rotate(0deg);
    }

    to {
        transform: rotate(359deg);
    }
}
#app .Input__input___3e_bf {
padding: 4px 8px;
    font-size: 14px;
    line-height: 2em;
    }
/*
main > * {
  background-color: white;
  position: relative;
}

main > :first-child {
  z-index: 1;
}

.next-leave-to {
  animation: leaveToLeft 500ms both cubic-bezier(0.165, 0.84, 0.44, 1);
  z-index: 0;
}

.next-enter-to {
  animation: enterFromRight 500ms both cubic-bezier(0.165, 0.84, 0.44, 1);
  z-index: 1;
}

.prev-leave-to {
  animation: leaveToRight 500ms both cubic-bezier(0.165, 0.84, 0.44, 1);
  z-index: 1;
}

.prev-enter-to {
  animation: enterFromLeft 500ms both cubic-bezier(0.165, 0.84, 0.44, 1);
  z-index: 0;
}

@keyframes leaveToLeft {
  from {
    transform: translateX(0);
  }
  to {
    transform: translateX(-25%);
    filter: brightness(0.5);
  }
}

@keyframes enterFromLeft {
  from {
    transform: translateX(-25%);
    filter: brightness(0.5);
  }
  to {
    transform: translateX(0);
  }
}

@keyframes leaveToRight {
  from {
    transform: translateX(0);
  }
  to {
    transform: translateX(100%);
  }
}

@keyframes enterFromRight {
  from {
    transform: translateX(100%);
  }
  to {
    transform: translateX(0);
  }
}
*/
#app > #page > .menu {
}
body.sidebar-menu >  #app .navbar {
width: 50%;
margin-left: 50%;
}
.ag-cell-editor-autocomplete {
    background-color: #f5f6fa;
    z-index: 1000;
    overflow-y: auto;
    overflow-x: hidden;
    box-sizing: border-box;
    border: 1px solid rgba(50,50,50,.6);
    max-height: 25% !important;
    max-width: 25% !important;
    padding: 5px 20px;
}
</style>
